import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { FiscalYearBranchesViewLoader } from "../components/FiscalYearBranchesViewLoader";
import { ErpEntities } from "../ErpEntities";
import { ErpLayout } from '../ErpLayout';
import { ErpRouterProps } from "../ErpRouterProps";
import { ErpScopeField, ErpScopeMode } from "../ErpScope";

interface Props extends NSARouterMakerResult, ErpRouterProps { }

export default class FiscalYearListPage extends Component<Props>
{
    override render()
    {
        return (
            <ErpLayout
                {...this.props}
                mode={ErpScopeMode.Filter}
                fields={[ErpScopeField.Company, ErpScopeField.Branch]}
                pages={{
                    entity: ErpEntities.fiscal_year(this.props),
                    list: {
                        ui: {
                            getChildrenAfter: (id, _row) =>
                            {
                                if (!id)
                                    return null;
                                return (
                                    <div style={{ flexBasis: "100%", width: "100%" }}>
                                        <FiscalYearBranchesViewLoader {...this.props} fiscal_year_id={id} />
                                    </div>

                                );
                            },
                        },
                    }
                }}>
                <></>
            </ErpLayout>
        );
    }
}